export const LADE_AUSWAHLWERTE_CHECKPUNKT = "ladeAuswahlwerteCheckpunkt";
